export enum PackageAcquisitionLocation {
    Server = "Server",
    ExecutionTarget = "ExecutionTarget",
    NotAcquired = "NotAcquired"
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/packageAcquisitionLocation.ts